import * as React from 'react';
import { Platform, Text, View, StyleSheet } from 'react-native';
import * as AppUtilities from "../context/AppUtilities";
import * as AppConstants from "../context/AppConstants";
import * as AppState from "../context/AppState";
import { AppContext } from "../context/AppContext";
import { Divider } from 'react-native-paper';
import { CustomScrollView } from '../components/CustomScrollView';
import { CustomButton } from '../components/CustomButton';
import { TextInput } from 'react-native-paper';
import { useForm, Controller } from "react-hook-form";
import Markdown from 'react-native-markdown-display-fh';

const styles = StyleSheet.create({
  wrapper: {
    flex: 1,
    padding: 20,
  },
  heading: {
    fontSize: 18,
    fontWeight: "bold",
  },
  label: {
    fontSize: 14,
    fontWeight: "bold",
    paddingBottom: 10,
  },
  labelPadLeft: {
    fontSize: 14,
    fontWeight: "bold",
    paddingLeft: 5,
  },
  normal: {
    fontSize: 14,
    paddingRight: 10,
    flexShrink: 1,
  },
  divider: {
    marginVertical: 15,
  },
  line: {
    paddingBottom: 15,
    flexWrap: "wrap",
  },
  listItemStyle: {
    paddingLeft: 5,
  },
});

const markdownStyles = StyleSheet.create({
  heading1: {
    paddingBottom: 10,
  },
  heading2: {
    paddingVertical: 10,
  },
});

// https://github.com/iamacup/react-native-markdown-display/blob/master/src/lib/renderRules.js
const markdownRules = {
  text: (node, children, parent, styles, inheritedStyles = {}) => (
    <Text key={node.key} style={[inheritedStyles, styles.text]} selectable={true}>
      {node.content}
    </Text>
  ),
};

export function News({ navigation }) {
  const { showPermanentSnack, showTemporarySnack, hideSnack, getLoginState, showSpinner, hideSpinner } = React.useContext(AppContext);
  const [newsMarkdown, setNewsMarkdown] = React.useState("Loading...");

  const { register, control, handleSubmit, setValue, reset, formState: { errors } } = useForm({
    defaultValues: {
      email: "",
    }
  });

  async function loadNews() {
    try {
      showSpinner();
      hideSnack();

      AppUtilities.info("News.loadNews fetching");

      const response = await AppUtilities.fetchUnauthorized("News.loadNews", "/find_humane/api/news");
      if (response.body) {
        hideSpinner();
        //AppUtilities.debug("News.loadNews results: " + AppUtilities.toJSONPretty(response.body));
        setNewsMarkdown(response.body.news.markdown);
      } else {
        throw new Error("Result body not found");
      }
    } catch (e) {
      showPermanentSnack(AppUtilities.getErrors(e), "Retry", loadNews);
      hideSpinner();
      AppUtilities.handleException(e, "News.loadNews");
    }
  }

  React.useEffect(() => {
    loadNews();
  }, []);

  async function onSubmit(data) {
    try {
      showSpinner();
      hideSnack();

      await AppUtilities.sendDebugDirect(AppUtilities.toJSONPretty(Object.assign({}, { form: "newsletter" }, data)));

      showTemporarySnack("You're on the list!");

      reset();

      navigation.pop();

    } catch (e) {
      showPermanentSnack(AppUtilities.getErrors(e), "Retry", () => onSubmit(data));
      AppUtilities.handleException(e, "News.onSubmit");
    } finally {
      hideSpinner();
    }

  }

  async function onValidationErrors(errors) {
    showTemporarySnack("There are some errors in the form");
  }

  return (
    <CustomScrollView>

      <View style={styles.line}>
        <Text style={styles.heading} selectable={true}>Newsletter</Text>
      </View>

      <Text selectable={true} style={styles.normal}>Enter your email to sign up for our newsletter:</Text>
      <Divider style={AppConstants.STYLES.marginVertical10} />

      <Controller
        control={control}
        rules={{
          required: true,
        }}
        render={({ field: { onChange, onBlur, value } }) => (
          <TextInput
            label="Your email"
            value={value}
            onChangeText={onChange}
            style={AppConstants.STYLES.width100PmarginVertical10borderNone}
            mode="outlined"
            dense={true}
            returnKeyType="next"
            onBlur={onBlur}
            autoComplete="email"
            keyboardType="email-address"
            textContentType="emailAddress"
          />
        )}
        name="email"
      />
      {errors.email && <Text selectable={true} style={AppConstants.STYLES.fontBoldColorRed}>Email is required.</Text>}

      <CustomButton
        onPress={handleSubmit(onSubmit, onValidationErrors)}
        style={AppConstants.STYLES.paddingVertical10}
      >Submit</CustomButton>

      <Divider style={AppConstants.STYLES.marginVertical20} />

      <Markdown style={markdownStyles} rules={markdownRules}>
        {newsMarkdown}
      </Markdown>

    </CustomScrollView>
  );
}
